module.exports = __webpack_public_path__ + "img/zx_zhu2.fe7a0002.png";